import { createRoot } from 'react-dom/client';
export default function renderComponent(_a) {
    var component = _a.component, target = _a.target;
    var domNode = document.getElementById(target);
    if (domNode !== null) {
        var root = createRoot(domNode);
        root.render(component);
    }
}
